import { useCallback } from 'react';
import { useRouter } from 'next/router';
import useCookie from './useCookie';
import { LOCALE_COOKIE_NAME } from '../constants';

type UseLanguageChange = {
  onLanguageChange: (newLang: string) => void;
};

const useLanguageChange = (): UseLanguageChange => {
  const router = useRouter();
  const [, setCookie] = useCookie(LOCALE_COOKIE_NAME);

  const onLanguageChange = useCallback((language: string) => {
    setCookie(language, {
      expires: 365,
      path: '/',
    });
    router.push(
      {
        pathname: router.pathname,
        query: router.query,
      },
      router.asPath,
      { locale: language },
    );
  }, [router, setCookie]);

  return { onLanguageChange };
};
export default useLanguageChange;
